import { createModel } from "hox";
import { useState } from "react";
import { userService } from "./UserService";
import { TablePaginationConfig } from "antd/es/table/interface";
import { EditModeType, IPgProps, ISearchPage } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdUserDetail, IMdUserFields } from "./UserTypes";
import { dictService } from "../../base/dict/DictService";
import { ISelectOption, ITreeData } from "@src/components/YhFormBox/Types";
import { organService } from "../../base/org/organizationService";
import { roleService } from "../role/RoleService";
import storeService from "../../base/store/StoreService";
import { convertRes2Blob } from "@src/utils/exportFile";
import { useOrganizationModel } from "../../base/org/organizationModel";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}


function useModel() {

    const initSearchParam: IMdUserFields = {};
    const initDataSource: IMdUserDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdUserFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdUserDetail[]>(initDataSource);
    //表格选中行
    const [selectedRow, setSelectedRow] = useState<IMdUserDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);
    const [pwdVisible, setPwdVisible] = useState(false);
    const [transferVisible, setTransferVisible] = useState(false);
    // 详情类型
    const [editType, setEditType] = useState<EditModeType>()
    const [resetState, setResetState] = useState(false)

    const [addressDs, setAddressDs] = useState<ISelectOption[]>()
    const [userTypeDs, setUserTypeDs] = useState<ISelectOption[]>()
    const [roleDs, setRoleDs] = useState<ISelectOption[]>()
    const [shopDs, setShopDs] = useState<ISelectOption[]>()
    const [orgDs, setOrgDs] = useState<ITreeData[]>()
    const { getOrgTreeSelect } = useOrganizationModel(() => []);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }

    /**
     * 加载选择项
     */
    const loadDs = async () => {
        let addds = await dictService.dictItemDs('address');
        let userTypes = await dictService.dictItemDs('user-type');
        let orgds = await getOrgTreeSelect('org')
        let roleds = await roleService.roleDs({})
        let shopds = await storeService.storeDs({})
        setAddressDs(addds)
        setRoleDs(roleds)
        setShopDs(shopds)
        setOrgDs(orgds)
        setUserTypeDs(userTypes)
    }

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdUserFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const loadData = async (page?: ISearchPage, searchValue: IMdUserFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await userService.findUserDetail(searchParams);
        // let { retData } = await userService.page(searchParams);
        const { records, ...pg } = retData;
        records.forEach(item => {
            item.shopIds = item.shops?.map(item => item.code as string)
        })
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const syncData = async () => {

        let ret = await userService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData()

    }

    //销售单导出
    const exportUser = async () => {
        setExportLoading(true);
        try {
            let result = await userService.export();
            convertRes2Blob(result, "用户名单.xlsx");
            result && setExportLoading(false)
        } catch (err) { setExportLoading(false) }
    }

    const updateUserOrg = () => {
        userService.updateUserOrg().then(({ retData }) => {
            retData ? message.success("更新成功") : message.error("更新失败");
            loadData().then()
        })
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRow,
        pgCfg,
        drawerVisible,
        pwdVisible,
        resetState,
        editType,
        addressDs,
        orgDs,
        roleDs,
        shopDs,
        userTypeDs,
        exportLoading,
        transferVisible,
        /***method***/
        setDataSource,
        setSelectedRow,
        resetSearchParam,
        updateSearchParam,
        setEditType,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        setPwdVisible,
        syncData,
        onSearch,
        onReset,
        loadDs,
        exportUser,
        updateUserOrg,
        setTransferVisible,
    }

}


export const useUserModel = createModel(useModel);